import { render, staticRenderFns } from "./VeJwJingsaiGroupList.vue?vue&type=template&id=93b58654&scoped=true"
import script from "./VeJwJingsaiGroupList.vue?vue&type=script&lang=js"
export * from "./VeJwJingsaiGroupList.vue?vue&type=script&lang=js"
import style0 from "./VeJwJingsaiGroupList.vue?vue&type=style&index=0&id=93b58654&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93b58654",
  null
  
)

export default component.exports